import {
  Button,
  CheckboxInput,
  DropdownItem,
  DropdownMenu,
} from '@dev-spendesk/grapes';
import classnames from 'classnames';
import React from 'react';

import type { FilterTypeOption } from '../../../../filter-type';

interface TypeListFilterProps {
  label: string;
  activeFilters: FilterTypeOption[];
  setActiveFilters: (filters: FilterTypeOption[]) => void;
  filterOptions: {
    label: string;
    key: FilterTypeOption;
  }[];
  isDisabled?: boolean;
  isMonoValue?: boolean;
}

export const TypeListFilter = ({
  label,
  activeFilters,
  setActiveFilters,
  filterOptions,
  isDisabled = false,
  isMonoValue = false,
}: TypeListFilterProps) => {
  const getButtonLabel = () => {
    if (activeFilters.length === 0) {
      return label;
    }

    if (activeFilters.length === 1) {
      return (
        filterOptions.find(({ key }) => key === activeFilters[0])?.label ??
        label
      );
    }

    return `${label} (${activeFilters.length})`;
  };

  return (
    <DropdownMenu
      keepOpenOnSelect
      renderButton={(getToggleButtonProps) => (
        <Button
          {...getToggleButtonProps()}
          iconName="adjustments-horizontal"
          iconPosition="left"
          variant={
            activeFilters.length && !isDisabled
              ? 'secondaryInfo'
              : 'secondaryNeutral'
          }
          className={classnames(
            'text-content-primary body-m',
            activeFilters.length && !isDisabled && 'text-content-selected',
          )}
          text={getButtonLabel()}
          isDisabled={isDisabled}
          aria-selected={activeFilters.length > 0}
        />
      )}
      options={filterOptions}
      onSelect={({ key }) => {
        const isAlreadySelected = activeFilters.includes(key);

        if (isMonoValue) {
          setActiveFilters(isAlreadySelected ? [] : [key]);
          return;
        }

        if (isAlreadySelected) {
          const filteredSelectedOptions = activeFilters.filter(
            (s) => s !== key,
          );
          setActiveFilters(
            filteredSelectedOptions.length ? filteredSelectedOptions : [],
          );
        } else {
          setActiveFilters([...activeFilters, key]);
        }
      }}
      renderOption={(option) => {
        const isSelected = activeFilters.includes(option.key);
        return (
          <DropdownItem
            key={option.key}
            label={option.label}
            className="text-nowrap"
            isSelected={isSelected}
            prefix={
              !isMonoValue && (
                <CheckboxInput isChecked={isSelected} onChange={() => {}} />
              )
            }
          />
        );
      }}
    />
  );
};
